import { Editor } from "@tiptap/react";
import { Editor as CoreEditor } from "@tiptap/core";
import { Node as PMNode, Mark as PMMark } from "prosemirror-model";
import { extractValueSuffix } from "./extractValueSuffix";

export function transformMarksToNodes(editor: Editor | CoreEditor) {
    if (!editor || !editor.state) return;
    const { tr, doc, schema } = editor.state;

    const matches: Array<{ pos: number; mark: PMMark; node: PMNode }> = [];

    doc.descendants((node, pos) => {
        if (!node.isText) return;

        node.marks.forEach((mark) => {
            if (mark.type.name === "dataAttributes") {
                matches.push({ pos, mark, node });
            }
        });
    });

    // Apply all changes AFTER collecting to avoid position desync
    for (const { pos, mark, node } of matches) {
        tr.removeMark(pos, pos + node.nodeSize, mark.type);

        // Preserve any trailing label the author tagged along with the value
        // (e.g. "$24M YoY") — the atom node renders only the live value, so
        // without this the suffix would be lost at conversion. Stored as a
        // node attr and re-rendered inside the value's styled span.
        const suffix = extractValueSuffix(node.text);
        const attrs = suffix ? { ...mark.attrs, suffix } : mark.attrs;

        const modelNode = schema.nodes.modelVariable.create(attrs);
        tr.replaceWith(pos, pos + node.nodeSize, modelNode);
    }

    if (tr.docChanged) {
        editor.view.dispatch(tr);
    }
}

export function transformNodesToMarks(editor: Editor | CoreEditor) {
    if (!editor || !editor.state) return;
    const { tr, schema } = editor.state;

    editor.state.doc.descendants((node, pos, parent) => {
        if (node.type.name === "modelVariable") {
            // Replace the node with marked text
            const textNode = schema.text("_", [
                schema.marks.dataAttributes.create(node.attrs),
            ]);
            tr.replaceWith(pos, pos + node.nodeSize, textNode);
        }
    });

    if (tr.docChanged) {
        console.log("tr transformNodesToMarks", tr);
        editor.view.dispatch(tr);
    }
}
